import { styled } from "@mui/material/styles";
import { Fab } from "@mui/material";
import { TIPPSPIEL_BOX_SHADOW } from "../../../styles";

export const FabNewPostButton = styled(Fab, {
    shouldForwardProp: (prop) => prop !== "backgroundColor",
})<{ backgroundColor?: string }>(
    ({ backgroundColor = "var(--community-color-sunset-orange)" }) => ({
        backgroundColor,
        width: "3.125rem",
        height: "3.125rem",
        boxShadow: TIPPSPIEL_BOX_SHADOW,
        ":hover": {
            backgroundColor,
        },
    }),
);
